export const storeConfig = {
  // Replace with your exact store address for accurate geocoding
  originAddress: '2912 2nd Place, Lubbock, TX 79415',
  // If you know exact coordinates, set them to skip geocoding each time
  originCoords: { lat: 33.5979, lon: -101.9153 },
  deliveryRadiusMiles: 20
}
